import { api } from "./api";

export const formApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    contactUs: builder.mutation({
      query: (body) => ({
        url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/contactUs`,
        method: "POST",
        body,
      }),
    }),   
    fileUpload: builder.mutation({
      query: (body) => ({
        url: `${process.env.NEXT_PUBLIC_BEANSTALK_API_BASE_URL}upload/multiple-images`,
        method: "POST",
        body,
      }),
    }),   
    eventForm: builder.mutation({
      query: (body) => ({
        url: `${process.env.NEXT_PUBLIC_API_BASE_URL}/eventNewsletter`,
        method: "POST",
        body,
      }),
    }),   
  }),
});

export const { useContactUsMutation, useFileUploadMutation, useEventFormMutation } = formApiSlice; // ✅ Corrected export